module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"signin":"Войти","gift_description":"Зарегистрируйтесь и получите свои первые <span class=\u0027bolder\u0027>20 бонусных миллилитров</span>, которые вы сможете обменять на скидку в партнёрском магазине <span class=\u0027header__tooltip-link\u0027>Randewoo</span>!","detail":"Подробнее"}}')
  delete Component.options._Ctor
}
